<div class="tooltip">
  <div class="tooltip-header" *ngIf="tooltipTitle">{{ tooltipTitle }}</div>
  <div class="tooltip-content" [class.no-header]="!tooltipTitle" [style.max-width.px]="maxWidth">
    <ng-template #simpleText>
      {{ text }}
    </ng-template>
    <ng-container *ngTemplateOutlet="contentTemplate || simpleText; context: { $implicit: inputData }"> </ng-container>
  </div>
</div>
